import type { OceanAgent } from "@vida/currents-core";
import { useAgentIconUrl } from "../hooks/useAgentIconUrl";
import { iconForRole } from "../services/agentCatalog";

type Props = {
  agent: Pick<OceanAgent, "icon" | "iconS3Key" | "role" | "name">;
  className?: string;
  size?: "sm" | "md" | "lg";
};

const SIZE_CLASS = {
  sm: "agent-avatar-sm",
  md: "agent-avatar-md",
  lg: "agent-avatar-lg",
};

export function AgentAvatar({ agent, className = "", size = "md" }: Props) {
  const imageUrl = useAgentIconUrl(agent.iconS3Key);
  const fallback = agent.icon?.trim() || iconForRole(agent.role);
  const cls = `agent-avatar ${SIZE_CLASS[size]} ${className}`.trim();

  if (imageUrl) {
    return <img src={imageUrl} alt="" className={cls} />;
  }

  return (
    <span className={cls} aria-hidden>
      {fallback}
    </span>
  );
}
